function pluralize(singular, count) {
  if (count === 1) {
    return singular;
  }
  if (singular.endsWith('s')) {
    return singular;
  } // not implemented on IE. Mobile use only
  return `${singular}s`;
}

export default pluralize;
